@if (company$ | async; as company) {
  <div class="container">
    <hyperkit-typography
      class="page-title"
      variant="h1"
      align="left"
      color="primary"
      >Company Information</hyperkit-typography
    >
    <div class="company-info-grid">
      <div class="info-row">
        <hyperkit-badge variant="neutral" text="Company Name"></hyperkit-badge>
        <hyperkit-typography
          variant="emphasized"
          size="sm"
          align="left"
          color="primary"
          >{{ company.name }}</hyperkit-typography
        >
      </div>
      @if (company.city) {
        <div class="info-row">
          <hyperkit-badge
            variant="neutral"
            text="Company City"
          ></hyperkit-badge>
          <hyperkit-typography
            variant="emphasized"
            size="sm"
            align="left"
            color="primary"
            >{{ company.city }}</hyperkit-typography
          >
        </div>
      }
      @if (company.industry) {
        <div class="info-row">
          <hyperkit-badge
            variant="neutral"
            text="Company Industry"
          ></hyperkit-badge>
          <hyperkit-typography
            variant="emphasized"
            size="sm"
            align="left"
            color="primary"
            >{{ company.industry }}</hyperkit-typography
          >
        </div>
      }
      @if (company.state) {
        <div class="info-row">
          <hyperkit-badge
            variant="neutral"
            text="Company State"
          ></hyperkit-badge>
          <hyperkit-typography
            variant="emphasized"
            size="sm"
            align="left"
            color="primary"
            >{{ company.state }}</hyperkit-typography
          >
        </div>
      }
      <div class="info-row">
        <hyperkit-badge variant="neutral" text="Status"></hyperkit-badge>
        <hyperkit-typography
          variant="emphasized"
          size="sm"
          align="left"
          color="primary"
          >{{ company.status | uppercase }}</hyperkit-typography
        >
      </div>
      @if (company.country) {
        <div class="info-row">
          <hyperkit-badge variant="neutral" text="Country"></hyperkit-badge>
          <hyperkit-typography
            variant="emphasized"
            size="sm"
            align="left"
            color="primary"
            >{{ company.country }}</hyperkit-typography
          >
        </div>
      }
      <div class="info-row">
        <hyperkit-badge variant="neutral" text="Member Since"></hyperkit-badge>
        <hyperkit-typography
          variant="emphasized"
          size="sm"
          align="left"
          color="primary"
          >{{ company.memberSince | date }}</hyperkit-typography
        >
      </div>
    </div>
  </div>
} @else {
  <div class="loading-state">
    <hyperkit-typography variant="body" color="secondary">
      Loading company information...
    </hyperkit-typography>
  </div>
}
